export const PACKAGE_VERSION = "9.5.1-beta.1";
